import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import { PATHS } from "../../../constants/paths";
import { checkRole } from "../../../hoc";

const CustomersPage = lazy(() => import("../Customers"));
const CustomerPage = lazy(() => import("../Customer"));
const CustomerGeneralInfoTabPage = lazy(
  () => import("../tabs/CustomerGeneralInfo")
);
const CustomerUsersTabPage = lazy(() => import("../tabs/CustomerUsers"));
const CustomerInsightsConfigTabPage = lazy(
  () => import("../tabs/CustomerInsightsConfig")
);

const CustomerWidgetsTabPage = lazy(() => import("../tabs/CustomerWidgets"));
const CustomerRestApiTokenPage = lazy(
  () => import("../tabs/CustomerRestApiToken")
);

const PersonasPromptsTabPage = lazy(
  () => import("../tabs/CustomerPersonasPrompt")
);
const CustomerAgentSettingsTabPage = lazy(
  () => import("../tabs/CustomerAgentSettings")
);

const useCustomerRoutes = () => {
  const isAdmin = checkRole("mgmt_admin");
  const isSuperadmin = checkRole("superadmin");

  return (
    <Route path={PATHS.Customers.Path}>
      <Route path="" element={<CustomersPage />} />
      <Route
        path={PATHS.Customers.Pages.Customer.Path}
        element={<CustomerPage />}
      >
        <Route
          path={PATHS.Customers.Pages.Customer.Tabs.CustomerGeneralInfoTab.Path}
          element={<CustomerGeneralInfoTabPage />}
        />
        <Route
          path={PATHS.Customers.Pages.Customer.Tabs.CustomerUsersTab.Path}
          element={<CustomerUsersTabPage />}
        />
        <Route
          path={PATHS.Customers.Pages.Customer.Tabs.RestApiToken.Path}
          element={<CustomerRestApiTokenPage />}
        />
        <Route
          path={
            PATHS.Customers.Pages.Customer.Tabs.CustomerInsightsConfigTab.Path
          }
          element={<CustomerInsightsConfigTabPage />}
        />
        {isAdmin && (
          <Route
            path={PATHS.Customers.Pages.Customer.Tabs.CustomerWidgetsTab.Path}
            element={<CustomerWidgetsTabPage />}
          />
        )}
        {isAdmin && (
          <Route
            path={PATHS.Customers.Pages.Customer.Tabs.Agents.Path}
            element={<CustomerAgentSettingsTabPage />}
          />
        )}
        {isSuperadmin && (
          <Route
            path={PATHS.Customers.Pages.Customer.Tabs.PersonasPromptsTab.Path}
            element={<PersonasPromptsTabPage />}
          />
        )}
        <Route
          index
          element={
            <Navigate
              replace
              to={
                PATHS.Customers.Pages.Customer.Tabs.CustomerGeneralInfoTab.Path
              }
            />
          }
        />
      </Route>
    </Route>
  );
};

export { useCustomerRoutes };
